import useAllData from "~/hooks/useAllData";
import type { Invitation } from "~/types/collections";
import type { Where } from "~/util/payload";

// Define the type for the parameters of useGetAllInvitations
interface UseGetAllInvitationsParams {
  depth?: number;
  where?: Where;
  serialLoading?: boolean;
  status?: string;
}

// Define the return type for useGetAllInvitations
interface UseGetAllInvitationsReturn {
  data: Invitation[] | undefined;
  totalItems: number;
  isLoading: boolean;
  isUpdating: boolean;
  refetch: () => void;
}

const useGetAllInvitations = ({
  depth,
  where,
  serialLoading,
  status,
}: UseGetAllInvitationsParams = {}): UseGetAllInvitationsReturn => {
  const newWhere = where || ({} as Where);

  newWhere["and"] = [];

  if (status) {
    newWhere["status"] = {
      equals: status,
    };
  }

  const result = useAllData<Invitation>({
    collection: "invitations",
    where: newWhere,
    depth,
    serialLoading,
  });

  return {
    data: result.data,
    totalItems: result.totalItems,
    isLoading: result.isLoading,
    isUpdating: result.isUpdating,
    refetch: result.refetch,
  };
};

export default useGetAllInvitations;
